import { ModelApi } from '@/services/api/modelApi'
import { ILocalDelivery } from '@/modules/preference/local-delivery/types/localDeliveryTypes'

/**
 * Local Delivery endpoint extends model api to inherit its methods and custom methods up to its needs
 * @param url is the module names which will
 */
export class LocalDeliveryEndpoints extends ModelApi<ILocalDelivery> {
  constructor() {
    super('local_delivery')
  }
}
